import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { DeviationSubmitActionPayloadType } from '../types';
import { actionKey } from '../constants';

export const submitDeviation = createAction(
  `${actionKey}.SUBMIT_DEVIATION`,
  (payload: DeviationSubmitActionPayloadType) => payload
);

export const submitDeviationSuccess = createAction(
  `${actionKey}.SUBMIT_DEVIATION_SUCCESS`,
  (payload: { contextId?: string; deviation: PapiDeviation; isPublished: boolean }) => payload
);

export const publishDeviation = createAction(
  `${actionKey}.PUBLISH_DEVIATION`,
  (payload: {
    deviation: PapiDeviation;
    onSuccess?: (response: any) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const publishDeviationSuccess = createAction(
  `${actionKey}.PUBLISH_DEVIATION_SUCCESS`,
  (deviation: PapiDeviation) => ({ deviation })
);

export const publishDeviationError = createAction(
  `${actionKey}.PUBLISH_DEVIATION_ERROR`,
  (deviation: PapiDeviation, response: any) => ({ deviation, response })
);

export const deleteDeviation = createAction(
  `${actionKey}.DELETE_DEVIATION`,
  (deviation: PapiDeviation) => ({ deviation })
);
